import { Skeleton } from "@mui/material";
import * as React from "react";
import { useParams } from "react-router-dom";

import { PageLayout } from "@/shared/components";
import { EntityComments } from "@/shared/components/comments";
import { ErrorBoundary } from "@/shared/components/ErrorBoundary";

import { FileLoadAlert } from "./ErrorBoundary";
import { FileContent } from "./FileContent";
import { FileActions } from "./FileHeader/FileActions";
import { FileSource, FileSourceSkeleton } from "./FileHeader/FileSource";

export function File() {
  const { fileId } = useParams();

  if (fileId === undefined) {
    // Programming error. FileId should be validated as part of loader
    throw new Error("FileId not provided");
  }

  return (
    <ErrorBoundary
      fallback={(props) => {
        return (
          <PageLayout title={`Roboto - File - ${fileId}`}>
            <FileLoadAlert error={props.error} />
          </PageLayout>
        );
      }}
    >
      <PageLayout
        title={`Roboto - File - ${fileId}`}
        headerContentLeft={
          <React.Suspense fallback={<FileSourceSkeleton />}>
            <FileSource fileId={fileId} />
          </React.Suspense>
        }
        headerContentRight={
          <React.Suspense>
            <FileActions fileId={fileId} />
          </React.Suspense>
        }
      >
        <React.Suspense
          fallback={
            <Skeleton animation="wave" variant="rounded" height={"400px"} />
          }
        >
          <FileContent fileId={fileId} />
          <div style={{ marginTop: "1.5rem" }}>
            <EntityComments entityType={"file"} entityId={fileId} />
          </div>
        </React.Suspense>
      </PageLayout>
    </ErrorBoundary>
  );
}
